/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class JiraServiceManagementProjectFieldsRequest {
    getFixupPrototypeFunction() { return JiraServiceManagementProjectFieldsRequest.fixupPrototype; }

    static newInstance(model: Partial<JiraServiceManagementProjectFieldsRequest>): JiraServiceManagementProjectFieldsRequest {
        let obj = Object.assign(new JiraServiceManagementProjectFieldsRequest(), model);
        JiraServiceManagementProjectFieldsRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<JiraServiceManagementProjectFieldsRequest>): JiraServiceManagementProjectFieldsRequest {
        if (!model) return null;
        return JiraServiceManagementProjectFieldsRequest.newInstance(<JiraServiceManagementProjectFieldsRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: JiraServiceManagementProjectFieldsRequest) {
        if (!obj) return;

        models.JiraServiceManagementProjectFieldsRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: JiraServiceManagementProjectFieldsRequest): boolean {
        Object.setPrototypeOf(obj, JiraServiceManagementProjectFieldsRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Service Account ID
     */
    service_account_id: string;

    /**
     * Jira Service Management Issue Type
     */
    issue_type: models.JiraServiceManagementIssueType;

}
